<div class="container">
	<h1 *ngIf="title" class="title">{{ title }}</h1>
	<p *ngIf="info" class="info">{{ info }}</p>
	<div *ngIf="mainButton" (click)="dismiss(true)" class="button button_main" role="button" tabindex="0">
		{{ mainButton }}
	</div>
	<div *ngIf="closeButton" (click)="dismiss(false)" class="button button_close" role="button" aria-label="Close button">
		{{ closeButton }}
	</div>
</div>
